import { gql } from '@apollo/client'

export const SEARCH_GCDM_PRODUCTS = gql`
  query ($input: GcdmProductSearchInput) {
    searchGcdmProducts(input: $input) {
      total
      items {
        gpid_list
        displayTitle
        artistDisplayTitle
        artistId
        releaseDate
        type
        subType
      }
    }
  }
`
